module.exports = __webpack_public_path__ + "img/health.17e211bb.gif";